import searchDevices from '../../utilities/searchDevices';
import type { DeviceResultsByLocation } from './utils';

export type LocationResult = DeviceResultsByLocation[string];

// The Screens page search keeps a location whose name matches with all its
// devices, so searching a location works as it always has, an empty location
// included. Any other location is kept only by its matching devices, and
// shows only those, so a search for a device lands on that one screen.
export const searchLocations = (
  results: LocationResult[],
  searchQuery: string,
) => {
  const query = searchQuery.trim().toLowerCase();
  if (!query) return results;
  const nameMatches = (r: LocationResult) =>
    (r.location?.name ?? '').toLowerCase().includes(query);
  return results
    .map((r) =>
      nameMatches(r) ? r : { ...r, devices: searchDevices(r.devices, query) },
    )
    .filter((r) => nameMatches(r) || r.devices.length > 0);
};
